import Utilities from '@util/Utilities';
import React from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';
import CompetitorsPriceRateAlertExecutionNotificationOutput
	from '@app/model/alert/output/CompetitorsPriceRateAlertExecutionNotificationOutput';
import RateChange from './RateChange';

const CompetitorsPriceRateNotificationRowFragment: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	alertExecution: AlertExecution,
	notificationOutput: CompetitorsPriceRateAlertExecutionNotificationOutput
}> = ({ alertExecution, notificationOutput }) => {


	const findCompetitor = (competitorId: number) => {
		return alertExecution.alertOutput.competitors!.find(c => c.id === competitorId);
	};

	const displayAverage = (average: number, title: string) => {
		return <>
			<span className="font-semibold text-gray-950">{title}: </span>
			<RateChange rate={average} variant="text" />
		</>;
	};

	const formatRoomFound = (fromRoomName: string, toRoomName: string) => {
		if (fromRoomName === toRoomName) {
			return <>{fromRoomName} <span className="text-gray-500">(Same Room)</span></>;
		}

		return <>{fromRoomName} <span className="text-gray-500">→</span> {toRoomName}</>;
	};

	return <tbody className="divide-y divide-gray-200" key={notificationOutput.notificationId}>
	<tr className="bg-gray-100">
		<td colSpan={2}
			className="whitespace-nowrap py-2 pl-0 pr-3 text-sm font-bold text-gray-950">
			<span className="mr-1">•</span>
			<span>{Utilities.formatDateString(notificationOutput.statDate, 'ddd DD MMM', false)}</span>
		</td>
		<td colSpan={3} className="whitespace-nowrap px-2 py-2 text-right text-sm">
			{displayAverage(notificationOutput.average, 'Average Change')}
		</td>
	</tr>
	{notificationOutput.competitorPriceRateChanges.map(change => {
		return <tr key={change.competitorId}>
			<td className="whitespace-normal py-4 pl-0 pr-3 text-sm font-medium text-gray-950">
				{findCompetitor(change.competitorId)?.name}
				{change.isNew &&
					<span className="ml-2 inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700">New</span>}
				{change.isUpdated &&
					<span className="ml-2 inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700">Updated</span>}
			</td>
			<td className="whitespace-nowrap px-2 py-4 text-sm text-gray-600">
				{Utilities.snakeCaseToWords(change.current.fromRoomType)}
			</td>
			<td className="whitespace-nowrap px-2 py-4 text-sm text-gray-600">
				<span>{Utilities.formatDouble(change.current.from, 0)}</span>
				<span className="mx-1 text-gray-400">→</span>
				<span>{Utilities.formatDouble(change.current.to, 0)}</span>
			</td>
			<td className="whitespace-normal px-2 py-4 text-sm leading-6 text-gray-600">
				{formatRoomFound(change.current.fromRoomName, change.current.toRoomName)}
			</td>
			<td className="whitespace-nowrap py-4 pl-3 pr-0 text-sm">
				<RateChange rate={change.current.rate} />
			</td>
		</tr>;
	})}
	</tbody>;
};

export default CompetitorsPriceRateNotificationRowFragment;
